import styled from '@emotion/styled';
import Avatar from 'antd/lib/avatar/avatar';

export const SadaKAvatar = styled(Avatar)`
  flex-shrink: 0;
`;
